import React from 'react';
import Loading from './Loading';
import './RefreshingSticker.scss';

const RefreshingSticker = () => (
  <div className="refreshingsticker flexed-row">
    <Loading color="black" />
    <span>Refreshing...</span>
  </div>
);

export default RefreshingSticker;
